/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputEwFrequencyRange
 */
export interface OutputEwFrequencyRange {
    /**
     * 
     * @type {number}
     * @memberof OutputEwFrequencyRange
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputEwFrequencyRange
     */
    min?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwFrequencyRange
     */
    unit?: string;
}

/**
 * Check if a given object implements the OutputEwFrequencyRange interface.
 */
export function instanceOfOutputEwFrequencyRange(value: object): boolean {
    return true;
}

export function OutputEwFrequencyRangeFromJSON(json: any): OutputEwFrequencyRange {
    return OutputEwFrequencyRangeFromJSONTyped(json, false);
}

export function OutputEwFrequencyRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwFrequencyRange {
    if (json == null) {
        return json;
    }
    return {
        
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function OutputEwFrequencyRangeToJSON(value?: OutputEwFrequencyRange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'max': value['max'],
        'min': value['min'],
        'unit': value['unit'],
    };
}

